import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Handler from '../../Handler';

export const CommaNumberInput = (props) => {
  const { value, onChange, meta, onEnter } = props;
  const { t } = useTranslation();
  const [passwordShow, setPasswordShow] = useState(false);
  const [error] = useState(false);

  const viewValue = useMemo(() => {
    return value === null || value === '' ? null : Handler.numberWithCommas(value);
  }, [value]);

  const onChangeInput = useCallback(
    (e) => {
      let new_value = e.target.value;
      let number_value = new_value.startsWith('-') ? '-' + new_value.slice(1) : new_value;
      onChange(number_value.replace(/[^\d-.]/g, ''), meta.key);
    },
    [onChange, meta.key],
  );

  const buildInputClassname = () => {
    if (error) {
      return 'error';
    } else {
      return null;
    }
  };

  const renderRequired = () => {
    if (meta && meta.required) {
      if (meta.className === 'point') {
        return <div className='ico required'></div>;
      } else {
        return <span className='text-red-600'>*</span>;
      }
    }
  };

  return (
    <article
      className={Handler.BuildArticleClassname('form-commma-number-input', meta)}
      style={meta && meta.style ? { ...meta.style } : {}}
    >
      {meta.label && (
        <header>
          <span>{t(meta.label)}</span>
          {renderRequired()}
        </header>
      )}

      <div className='input__box'>
        <input
          className={buildInputClassname()}
          placeholder={meta.placeholder}
          disabled={meta.disabled || meta.readOnly}
          value={viewValue}
          onChange={onChangeInput}
          type={'text'}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (onEnter) {
                onEnter();
              }
            }
          }}
        ></input>
        {(meta.key === 'password' || meta.key === 'passwordConfirm') && (
          <div className='eye__box'>
            <div
              className={passwordShow ? 'ico eye-off' : 'ico eye'}
              onClick={() => {
                setPasswordShow(!passwordShow);
              }}
            ></div>
          </div>
        )}
        {meta.unitLabel && (
          <div className='unit__box'>
            <span>{meta.unitLabel}</span>
          </div>
        )}
      </div>
    </article>
  );
};
